
import { db, timestamp } from '../../firebase/config';
import { getDocs, query, where, doc, collection, onSnapshot, addDoc, arrayUnion, arrayRemove, updateDoc, FieldValue, serverTimestamp, setDoc } from "firebase/firestore";
import { v4 as uuidv4 } from 'uuid';
import { useState, useEffect } from "react";
import { useAuthContext } from "../../hooks/useAuthContext";
import { useCollection } from "../../hooks/useCollection";
import { useDocument } from "../../hooks/useDocument";


import formatDistanceToNow from 'date-fns/formatDistanceToNow'

export default function CipsComments({cip}) {


  const { user } = useAuthContext()
  const {document: comments} = useDocument ('comments', cip)
  const {document: replies} = useDocument ('replies', cip)

  const [newComment, setNewComment] = useState ('')
  const { documents: test } = useCollection('WDA_Cowlitz', ['matchCIP','array-contains-any',['110201']])

 const [reply, setReply] = useState('')
 const [newReply, setNewReply] = useState ('')

  // const onClick =  () => {



  const onClick =  async () => {

  const citiesRef = collection(db, "users");
  const q = query(citiesRef, where("district", "==", "renton"));
  const querySnapshot = await getDocs(q);
  querySnapshot.forEach((doc) => {
  // doc.data() is never undefined for query doc snapshots
//   updateProfile(user, {
//     phoneNumber: 100
// })
});

   }


   const onClicky = (commentId) => {
     setReply(commentId)
   }



    const handleSubmit = async (e) => {
      e.preventDefault()

      // if (comments['110201'].comment.length > 1) {
      // await updateDoc(ref2, {
      //   '110201.comment': arrayRemove(comments['110201'].cipName[1])
      // })}

      await updateDoc(doc (db, 'comments', cip), {
        'comment': arrayUnion ({
          displayName: user.displayName,
          text: newComment,
          uid: user.uid,
          districtName: user.photoURL,
          commentId:uuidv4(),
          createdAt:timestamp.fromDate(new Date())
        })
            })

      setNewComment('')
    }

    const handleDelete = async (commentId, createdAt, text ) => {
      await updateDoc(doc (db, 'comments', cip), {
     'comment': arrayRemove ({
       displayName: user.displayName,
       text: text,
       uid: user.uid,
       districtName: user.photoURL,
       commentId: commentId,
       createdAt: createdAt

      })
         } )

      }



      const handleReply = async (e) => {
        e.preventDefault()

        // if (comments['110201'].comment.length > 1) {
        // await updateDoc(ref2, {
        //   '110201.comment': arrayRemove(comments['110201'].cipName[1])
        // })}

        await updateDoc(doc (db, 'replies', cip), {
          'comment': arrayUnion ({
            displayName: user.displayName,
            text: newReply,
            uid: user.uid,
            districtName: user.photoURL,
            commentId: reply,
            replyId:uuidv4(),
            createdAt:timestamp.fromDate(new Date())
          })
              })

               setNewReply('')
      }




  return (
    <div className='w-full mt-12 bg-gray-100 px-12 py-6'>

<div className='mt-4'>
    <form onSubmit={handleSubmit}>
      <label>
      <textarea className={`bg-white rounded border border-indigo-100 leading-normal resize-none w-full py-2 px-3`}
       rows="6"
       type="text" placeholder="add notes..."
        onClick={() => {}}
        onChange={(e) => setNewComment(e.target.value)}
        value={newComment}/>
      </label>
      <button disabled={!newComment.length > 0}
                type="submit"
                className={!newComment.length > 0 ? "items-center border-2 border-transparent justify-center bg-gray-300 gap-1 flex flex-row my-1 w-[100px] py-2 text-sm text-slate-500 rounded-lg" :
                "items-center border-2 border-slate-300 justify-center bg-gray-400 hover:bg-indigo-500 hover:text-white hover:border-indigo-600 gap-1  flex flex-row my-1 w-[100px] py-2 p-3 text-sm text-slate-800 rounded-lg"
               }
              >
                <span className="justify-center">

                          </span>
                Submit
                 {/* <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-3 group-hover:text-indigo-200 text-slate-400" viewBox="0 0 20 20" fill="currentColor">
  <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z" />
</svg> */}
              </button>

    </form>
</div>

<main className='flex-col mt-12'>
  <header>

    <div className='flex flex-col-reverse'>
   {comments && comments.comment &&  (comments.comment.map ( (comment) =>
   <div className="px-12 border-t relative border-indigo-300 bg-gray-50 pt-3 pb-4 leading-none mt-6 rounded-lg rounded-tl-none">

   <span className='text-slate-900 font-semibold text-sm '>Taylor Smith,</span>
   <span className=' text-indigo-700 font-normal text-sm'>{` NuMetrics`}</span>
   <span className=' text-slate-700 font-light text-sm truncate'>{`, Director of Data and Analytics`}</span><br/>
   <p className='text-slate-500 font-light text-sm'>{comment.createdAt && formatDistanceToNow(comment.createdAt.toDate(), {addSuffix: true})}</p>
   {/* <button
   title="Reply"
   onClick={() => onClicky(comment.commentId)}
   className='items-center absolute z-50 border-2 border-transparent right-12 -top-2 justify-center bg-gray-100 hover:bg-indigo-500 hover:text-white hover:border-indigo-600 gap-1 flex flex-row my-4 w-18 p-2 text-sm text-slate-600 rounded-lg'><svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
  <path fillRule="evenodd" d="M7.707 3.293a1 1 0 010 1.414L5.414 7H11a7 7 0 017 7v2a1 1 0 11-2 0v-2a5 5 0 00-5-5H5.414l2.293 2.293a1 1 0 11-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
</svg>reply</button> */}
   <div className=''>
   <p className='text-slate-800 leading-normal whitespace-pre-line break-normal mt-2'>{comment.text}</p> <br/>

   <button
   title="delete"
   onClick={() => handleDelete(comment.commentId, comment.createdAt, comment.text)}
   className='items-center absolute z-50 border-2 border-transparent right-0 -top-2 justify-center bg-gray-100 hover:bg-indigo-500 hover:text-white hover:border-indigo-600 gap-1 flex flex-row my-4 w-10 p-2 text-sm text-slate-600 rounded-lg'>
   <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
</svg></button>

{/* REPLIES */}
   {replies && replies.comment &&  (replies.comment.map ( (re) => (

     comment.commentId === re.commentId ?
<div className='flex flex-col border-t-8 border-slate-50'>
     <div className='ml-8 border-t bg-gray-100 px-4 pt-2 pb-3 rounded-lg'><span className='text-slate-900 font-semibold text-sm'>{re.displayName}</span>
     <span className=' text-indigo-700 font-normal text-sm'>{` NuMetrics`}</span>
     <span className=' text-slate-700 font-light text-sm truncate'>{`, Director of Data and Analytics`}</span><br/>
     <p className='text-slate-500 font-light text-sm'>{`replied ${re.createdAt && formatDistanceToNow(re.createdAt.toDate(), {addSuffix: true})}`}</p>
     <p className='text-slate-800 leading-normal whitespace-pre-line break-normal mt-2'>{re.text}</p> <br/>

</div>
     </div>



     : null




   )))}







   {reply === comment.commentId ? <div>

    <div className='mt-4'>
    <form onSubmit={handleReply}>
      <label>
        {/* <span>Add a comment</span> */}
        <textarea className={`bg-white rounded border border-indigo-100 leading-normal resize-none w-full py-2 px-3`}
       rows="6"
       type="text" placeholder="Reply..."
        onClick={() => {}}
        onChange={(e) => setNewReply(e.target.value)}
        value={newReply}/>
      </label>
      <button disabled={!newReply.length > 0}
                type="submit"
                className={!newReply.length > 0 ? "items-center border-2 border-transparent justify-center bg-gray-300 gap-1 flex flex-row my-1 w-[100px] py-2 text-sm text-slate-500 rounded-lg" :
                "items-center border-2 border-slate-300 justify-center bg-gray-400 hover:bg-indigo-500 hover:text-white hover:border-indigo-600 gap-1  flex flex-row my-1 w-[100px] py-2 p-3 text-sm text-slate-800 rounded-lg"
               }
              >
                <span className="justify-center">

                          </span>
                Submit
                 {/* <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-3 group-hover:text-indigo-200 text-slate-400" viewBox="0 0 20 20" fill="currentColor">
  <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z" />
</svg> */}
              </button>

    </form>
</div>





   </div>
   : null}
   </div>

   </div>)) }

</div>
  </header>
</main>
    </div>
  )

  // const [cips, setCips] = useState([]);
  // const [isPending, setIsPending] = useState(null);
  // const [error, setError] = useState(false);

  // useEffect(() => {
  //   const fetchCip = async () => {
  //     const docRef = doc(db, "upsd", "upsd");
  //     const docSnap = await getDoc(docRef);
  //     if (docSnap.exists) {
  //       setCips(docSnap.data());
  //     } else {
  //       setIsPending(false);
  //       setError("Could not find that CIP");
  //     }
  //   };
  //   fetchCip();
  // }, []);


// return (
//  <div>
//  </div>

// )



//   if (typeof cips.cips == "undefined") {
//     return (
//       <div className="book-list">
//         <h1>loading...</h1>
//       </div>
//     );
//   } else {
//     return (
//       <div className="subCategories">
//         <table>
//           <thead>
//             <tr className="testing">
//               <th colSpan="2">The table header</th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr>
//               <td>The table body</td>
//               <td>with two columns</td>
//             </tr>
//           </tbody>
//         </table>

//         {cips.cips.map((cip) => (
//           <div className="ui_subheader">
//             <h1>{cip.cipName}</h1>
//             <table cellSpacing="0" cellPadding="4px">
//               <thead>
//                 <tr>
//                   <th colSpan="5">
//                     <h5 className="title-table">Enrollents</h5>
//                   </th>
//                 </tr>
//                 <tr className="title-header">
//                   <th>School Name</th>
//                   <th>2017</th>
//                   <th>2018</th>
//                   <th>2019</th>
//                   <th>TOTAL</th>
//                 </tr>
//               </thead>
//               {cip.cipSchooled.map((cipDetails) => (
//                 <tbody>
//                   <tr className="test-highlight">
//                     <td>{cipDetails.schoolName}</td>
//                     {cipDetails.cipEnrolledF.map((cipEnrollment) => (
//                       <td>{cipEnrollment}</td>
//                     ))}
//                   </tr>
//                 </tbody>
//               ))}
//             </table>
//           </div>
//         ))}
//       </div>
//     );
//   }
 }
